/** Mantener en sync con runtimeCaching de vite.config.js (ver CACHE.md). */
export const IMAGES_CACHE_VERSION = 'v1';
export const IMAGES_CACHE_NAME = `labpsi-images-${IMAGES_CACHE_VERSION}`;
